// extracted by mini-css-extract-plugin
module.exports = {"container":"CategoryTabs_container__1ZYGj","btn":"CategoryTabs_btn__2VNDb","dead":"CategoryTabs_dead__3EXQy"};